import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

export interface QuickViewProps {
  productToken: string | undefined;
}

export const productTileQuickViewPropsILeanProductTileAdapter = (
  productTile: ILeanProductTile
): QuickViewProps => {
  return { productToken: productTile.product?.token };
};
